import axios from '@/lib/axios';
import { PaymentTaskSubscription, PurchaseOrderContractTaskSubscription } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1040. 支払タスク購読解除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_subscriptions/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyPaymentTaskSubscriptions = (props: Props): Promise<PaymentTaskSubscription> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_subscriptions/${props.id}`
  );
};

export const useDestroyPaymentTaskSubscriptions = () => {
  return useMutation({
    mutationFn: destroyPaymentTaskSubscriptions,
  });
};
